import type { IControlSettingUI } from '~/presentation/reports/common/type';

const diffControlsBySelectedIds = (
  controls: IControlSettingUI[] | undefined,
  selectedIds: string[],
) => {
  const selectedSet = new Set(selectedIds);

  const existingControls: IControlSettingUI[] = [];
  const removedIds: string[] = [];
  const existingControlIdSet = new Set<string>();

  for (const control of controls ?? []) {
    const uid = control.uid;
    if (!uid) continue;

    if (selectedSet.has(uid)) {
      existingControls.push(control);
      existingControlIdSet.add(uid);
    } else {
      removedIds.push(uid);
    }
  }

  return { existingControls, removedIds, existingControlIdSet };
};

const buildNewControlUIs = (
  selectedIds: string[],
  existingControlIdSet: Set<string>,
  controlSettingUI?: Record<string, IControlSettingUI>,
) => {
  const added: IControlSettingUI[] = [];

  for (const id of selectedIds) {
    if (existingControlIdSet.has(id)) continue;

    const ui = controlSettingUI?.[id];
    if (ui) added.push(ui);
  }

  return added;
};

type BuildControlUIResult = {
  newControls: IControlSettingUI[];
  removedIds: string[];
};

export const buildControlUI = (data: {
  controls: IControlSettingUI[] | undefined;
  tempSelectedItems: string[];
  defaultControls?: IControlSettingUI[];
  controlSettingUI?: Record<string, IControlSettingUI>;
}): BuildControlUIResult => {
  const { controls, tempSelectedItems, defaultControls, controlSettingUI } = data;

  if (!controls?.length && !tempSelectedItems.length) {
    return { newControls: [], removedIds: [] };
  }

  const { existingControls, removedIds, existingControlIdSet } = diffControlsBySelectedIds(
    controls,
    tempSelectedItems,
  );

  const added = buildNewControlUIs(tempSelectedItems, existingControlIdSet, controlSettingUI);

  return {
    newControls: [...(defaultControls ?? []), ...existingControls, ...added],
    removedIds,
  };
};
